import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  initialValues,
  validationSchema,
} from "../../../componentes/Administrador_EmpresaRegistro";
import { useFormik } from "formik";
import { Form, Checkbox, Segment, Header, Grid } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { estiloColores } from "../../../estilos/colores";
import { apiEmpresa } from "../../../api/empresa";
import { apiLocalidad } from "../../../api/localidad";
import Swal from "sweetalert2";
import { ENTORNO } from "../../../utils/constantes";
import { setTitulo, getrole } from "../../../utils/variablesLocales";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { TextField } from "@material-ui/core";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { selecciona_localidad } from "../../../utils/traductor";

const apilocalidad = new apiLocalidad();
const apiempresa = new apiEmpresa();

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

export function EmpresaRegistro(props) {
  const [YaCargoComboLocalidad, setYaCargoComboLocalidad] = useState(0);

  setTitulo("Empresa");

  ////////////////////////////////

  const [localidades, setLocalidad1] =
    useState(
      null
    ); /*esta variable localidades, maneja el estado del item seleccionado en el combo localidades*/

  ////////////////////////////////

  /*este es como el load de asp.net*/
  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Administrador") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }
        ///////////////////////////////////////////////////////

        //obtengo la lista de localidades para luego cargar el combo
        if (YaCargoComboLocalidad === 0) {
          const respuesta = await apilocalidad.obtener();
          setLocalidad1(respuesta);

          setYaCargoComboLocalidad(1);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  });

  ////////////////////////////////

  const navigate = useNavigate();
  const parametro = useLocation();

  const navigateToEmpresaConsulta = () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/EmpresaConsulta");
  };

  const formik = useFormik({
    initialValues: initialValues(parametro.state),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (parametro.state.accion === "editar") {
          const respuesta = await apiempresa.actualizar(
            parametro.state.id,
            formik.values.nombre,
            formik.values.email,
            formik.values.telefono,
            "",
            formik.values.localidad,
            formik.values.activo
          );

          if (respuesta.status === 200) {
            Swal.fire({
              title: "",
              text: "Cambios registrados correctamente",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: estiloColores.Azul,
            }).then(function () {
              navigateToEmpresaConsulta();
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Error al guardar cambios",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: estiloColores.Gris,
            });
          }
        } else {
          const respuesta = await apiempresa.nuevo(
            formik.values.nombre,
            formik.values.email,
            formik.values.telefono,
            "",
            formik.values.localidad,
            formik.values.activo
          );
          if (respuesta.status === 200) {
            Swal.fire({
              title: "",
              text: "Registro creado correctamente",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: estiloColores.Azul,
            }).then(function () {
              navigateToEmpresaConsulta();
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Error al crear registro",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: estiloColores.Gris,
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  ////////////////////////////////

  var localidadRegistros = [];

  if (localidades) {
    for (let i = 0; i < localidades.length; i++) {
      localidadRegistros.push({
        key: localidades[i].Nombre,
        text: localidades[i].Nombre,
        value: localidades[i].Nombre,
      });
    }
  }

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <form onSubmit={formik.handleSubmit}>
        <React.Fragment>
          <CssBaseline />
          <AppBar style={{ background: "#DC030E" }}>
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                onClick={navigateToEmpresaConsulta}
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                Empresas - Registro
              </Typography>
              <IconButton
                size="large"
                aria-label="display more actions"
                edge="end"
                color="inherit"
                type="submit"
              >
                <CheckIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Toolbar id="back-to-top-anchor" />
          <Container>
            <Box sx={{ my: 2 }}>
              <Segment style={estiloSegmento.Administrador}>
                <Grid
                  textalign="center"
                  container
                  style={{ padding: "5em 0em", width: "100%" }}
                >
                  <div className="ingresar">
                    <Grid.Row>
                      <Grid.Column style={{ width: "100%" }}>
                        <Box
                          //component="form"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            "& > :not(style)": { m: 1, width: "100%" },
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <Header as="h3">Nombre</Header>
                          <TextField
                            id="email"
                            placeholder="Nombre"
                            variant="standard"
                            name="nombre"
                            type="text"
                            value={formik.values.nombre}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.nombre &&
                              Boolean(formik.errors.nombre)
                            }
                            helperText={
                              formik.touched.nombre && formik.errors.nombre
                            }
                          />
                          <Header as="h3">Email</Header>
                          <TextField
                            id="email"
                            placeholder="Email"
                            variant="standard"
                            name="email"
                            type="text"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.email &&
                              Boolean(formik.errors.email)
                            }
                            helperText={
                              formik.touched.email && formik.errors.email
                            }
                          />
                          <Header as="h3">Teléfono</Header>
                          <TextField
                            id="telefono"
                            placeholder="Teléfono"
                            variant="standard"
                            name="telefono"
                            type="text"
                            value={formik.values.telefono}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.telefono &&
                              Boolean(formik.errors.telefono)
                            }
                            helperText={
                              formik.touched.telefono && formik.errors.telefono
                            }
                          />
                          <Header as="h3">Localidad</Header>
                          <Form.Field>
                            <Form.Dropdown
                              name="localidad"
                              value={formik.values.localidad}
                              onChange={(_, data) =>
                                formik.setFieldValue("localidad", data.value)
                              }
                              error={formik.errors.localidad}
                              fluid
                              selection
                              placeholder={selecciona_localidad}
                              // options={localidadRegistros}
                              options={[
                                {
                                  key: "El Calafate",
                                  text: "El Calafate",
                                  value: "El Calafate",
                                },
                                {
                                  key: "Valencia",
                                  text: "Valencia",
                                  value: "Valencia",
                                },
                                {
                                  key: "Córdoba",
                                  text: "Córdoba",
                                  value: "Córdoba",
                                },
                                {
                                  key: "Ushuaia",
                                  text: "Ushuaia",
                                  value: "Ushuaia",
                                },
                                {
                                  key: "Santiago del Estero",
                                  text: "Santiago del Estero",
                                  value: "Santiago del Estero",
                                },
                                {
                                  key: "Colonia Caroya",
                                  text: "Colonia Caroya",
                                  value: "Colonia Caroya",
                                },
                              ]}
                            ></Form.Dropdown>
                          </Form.Field>
                          {/* <Box sx={{ minWidth: 120 }}>
                            <FormControl fullWidth>
                              <NativeSelect
                                value={formik.values.localidad}
                                inputProps={{
                                  name: "localidad",
                                  id: "localidad",
                                }}
                                onChange={(_, data) =>
                                  formik.setFieldValue("localidad", data.value)
                                }
                                error={formik.errors.localidad}
                              >
                                {localidadRegistros.map((opcion) => (
                                  <option key={opcion.value} value={opcion.value}>
                                    &nbsp; {opcion.text}
                                  </option>
                                ))}
                              </NativeSelect>
                            </FormControl>
                          </Box> */}
                          <br></br>
                          <Form.Field>
                            <Checkbox
                              name="activo"
                              label="Activo"
                              checked={formik.values.activo}
                              onChange={() =>
                                formik.setFieldValue(
                                  "activo",
                                  !formik.values.activo
                                )
                              }
                            />
                          </Form.Field>
                        </Box>
                      </Grid.Column>
                    </Grid.Row>
                  </div>
                </Grid>
              </Segment>
            </Box>
          </Container>
          <ScrollTop {...props}>
            <Fab size="small" aria-label="scroll back to top">
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
        </React.Fragment>
      </form>
    </div>
  );
}
